<app-modal [modalTitle]="title">
	<div class="modal-body p-4" [innerHTML]="bodyText">
	</div>

	<div class="modal-footer">
		<button class="btn md btn-alt" type="button" (click)="activeModal.close(false)">
			Nee
		</button>

		<button class="btn md btn-save" type="button" (click)="activeModal.close(true)">
			Ja
		</button>
	</div>
</app-modal>